import { render, staticRenderFns } from "./writefulList.vue?vue&type=template&id=95320efe&scoped=true"
import script from "./writefulList.vue?vue&type=script&lang=js"
export * from "./writefulList.vue?vue&type=script&lang=js"
import style0 from "./writefulList.vue?vue&type=style&index=0&id=95320efe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95320efe",
  null
  
)

export default component.exports